/* tslint:disable */
/* eslint-disable */
/**
 * A2B Enrich/Validate API
 * Internal API for enriching/validating common data
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@a2b-internet.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BadRequest } from '../model';
// @ts-ignore
import type { CocNumberValidationResult } from '../model';
// @ts-ignore
import type { ValidateVatNumber400Response } from '../model';
// @ts-ignore
import type { VatNumberValidationResult } from '../model';
/**
 * ValidateApi - axios parameter creator
 */
export const ValidateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Validate a Dutch Chamber of Commerce number and retrieve company information
         * @param {string} number The Chamber of Commerce to validate
         * @param {string} [acceptLanguage] Sets the language for error messages (default en)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCocNumber: async (number: string, acceptLanguage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('validateCocNumber', 'number', number)
            const localVarPath = `/v1/validate/coc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (number !== undefined) {
                localVarQueryParameter['number'] = number;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate an EU VAT number and retrieve information
         * @param {string} number The VAT number to validate
         * @param {string} [acceptLanguage] Sets the language for error messages (default en)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVatNumber: async (number: string, acceptLanguage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('validateVatNumber', 'number', number)
            const localVarPath = `/v1/validate/vatNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (number !== undefined) {
                localVarQueryParameter['number'] = number;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateApi - functional programming interface
 */
export const ValidateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ValidateApiAxiosParamCreator(configuration)
    return {
        /**
         * Validate a Dutch Chamber of Commerce number and retrieve company information
         * @param {string} number The Chamber of Commerce to validate
         * @param {string} [acceptLanguage] Sets the language for error messages (default en)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateCocNumber(number: string, acceptLanguage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CocNumberValidationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateCocNumber(number, acceptLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidateApi.validateCocNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate an EU VAT number and retrieve information
         * @param {string} number The VAT number to validate
         * @param {string} [acceptLanguage] Sets the language for error messages (default en)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateVatNumber(number: string, acceptLanguage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VatNumberValidationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateVatNumber(number, acceptLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValidateApi.validateVatNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ValidateApi - factory interface
 */
export const ValidateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ValidateApiFp(configuration)
    return {
        /**
         * Validate a Dutch Chamber of Commerce number and retrieve company information
         * @param {ValidateApiValidateCocNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateCocNumber(requestParameters: ValidateApiValidateCocNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<CocNumberValidationResult> {
            return localVarFp.validateCocNumber(requestParameters.number, requestParameters.acceptLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate an EU VAT number and retrieve information
         * @param {ValidateApiValidateVatNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateVatNumber(requestParameters: ValidateApiValidateVatNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<VatNumberValidationResult> {
            return localVarFp.validateVatNumber(requestParameters.number, requestParameters.acceptLanguage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for validateCocNumber operation in ValidateApi.
 */
export interface ValidateApiValidateCocNumberRequest {
    /**
     * The Chamber of Commerce to validate
     */
    readonly number: string

    /**
     * Sets the language for error messages (default en)
     */
    readonly acceptLanguage?: string
}

/**
 * Request parameters for validateVatNumber operation in ValidateApi.
 */
export interface ValidateApiValidateVatNumberRequest {
    /**
     * The VAT number to validate
     */
    readonly number: string

    /**
     * Sets the language for error messages (default en)
     */
    readonly acceptLanguage?: string
}

/**
 * ValidateApi - object-oriented interface
 */
export class ValidateApi extends BaseAPI {
    /**
     * Validate a Dutch Chamber of Commerce number and retrieve company information
     * @param {ValidateApiValidateCocNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateCocNumber(requestParameters: ValidateApiValidateCocNumberRequest, options?: RawAxiosRequestConfig) {
        return ValidateApiFp(this.configuration).validateCocNumber(requestParameters.number, requestParameters.acceptLanguage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate an EU VAT number and retrieve information
     * @param {ValidateApiValidateVatNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateVatNumber(requestParameters: ValidateApiValidateVatNumberRequest, options?: RawAxiosRequestConfig) {
        return ValidateApiFp(this.configuration).validateVatNumber(requestParameters.number, requestParameters.acceptLanguage, options).then((request) => request(this.axios, this.basePath));
    }
}

